export const mapClassNameFromCSSModule = (className: string, styles: Record<PropertyKey, string>): string => {
  return className
    .split(' ')
    .map(name => styles[name])
    .join(' ');
};

export const calcRowsByLineLimit = (value: string, limit: number): number => Math.ceil(value.length / limit);
